import PortraitPolicy from './portrait-policy'
export default PortraitPolicy
